import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { LABELS } from '@/constants/common/message.constants'

import { NumberFormatter } from '../NumberFormatter'
import { Spinner } from '../Spinner'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** 合計件数。null の場合はローディング扱いで「--件」を表示 */
  count: number | null
  /**
   * 読み上げ用ラベル。指定なしの場合は「検索結果 合計 {count}件」を自動生成
   * @example 検索結果 合計 123件
   */
  ariaLabel?: string
}

/**
 * 検索結果の合計件数表示（見た目とアクセシビリティのみ担当）
 */
export const CountSummary: FC<Props> = ({
  count,
  className,
  ariaLabel,
  ...props
}) => {
  const isLoading = count == null
  const displayCount = isLoading ? '--' : count

  // スクリーンリーダー用
  const label =
    ariaLabel ??
    LABELS.SEARCH_RESULT_TOTAL_ARIA_LABEL.replace(
      '{count}',
      String(displayCount)
    )

  // ローディング中はスピナーを表示
  const display = isLoading ? (
    <Spinner size="x-small" />
  ) : (
    <NumberFormatter value={count} />
  )

  return (
    <div
      {...props}
      className={clsx('text-black', className)}
      aria-label={label}
      aria-live="polite"
    >
      {LABELS.TOTAL}: {display}
      {LABELS.COUNT_UNIT}
    </div>
  )
}
